import * as React from "react"
// import IconSearch from "../svg/IconSearch"

interface ISearchBox {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  closeFn: () => void
  refElem: React.MutableRefObject<HTMLInputElement>
}

const SearchBox: React.FC<ISearchBox> = (props) => {
  const { value, onChange, refElem, closeFn } = props
  return (
    <div
      className="dropdownSelect__searchBox"
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
      }}
    >
      <div
        className="dropdownSelect__back"
        onClick={closeFn}
      ></div>
      <input
        type="text"
        placeholder="Search here"
        ref={refElem}
        onChange={onChange}
        value={value}
      />
      <div className="dropdownSelect__icon" style={{ right: 20 }}>
        {/* <IconSearch /> */}
      </div>
    </div>
  )
}

export default SearchBox
